export const getRandomEl = <T>(arr: T[]): T =>
  arr[Math.floor(Math.random() * arr.length)];
